<template>
  <div style="width: 100%;height: 100%;">
    <!--头部-->
    <e-header></e-header>
    <!--内容区开始-->
    <div class="contentWrap">
    <router-view ></router-view>
    </div>
    <!--脚部-->
    <e-footer></e-footer>
  </div>
</template>
<script>
  import header from './components/header/header.vue'
  import footer from './components/footer/footer.vue'
  export default {
    data(){
      return {
        firstPageMsg: {}

      }
    },
    created () {

    },
    methods:{

    },
    components: {
      'e-footer': footer,
      'e-header': header
    },
    watch: {//使用watch 监听$router的变化
      $route(to, from) {
        window.scrollTo(0, 0)
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "./common/stylus/mixin.styl"
  html, body
    height 100%
  .contentWrap
    padding-top 55px
    width 100%
    min-height 100%
    margin 0 auto
</style>





// WEBPACK FOOTER //
// src/app.vue